import React from "react"
import ReCAPTCHA from "react-google-recaptcha"

export default ({ onChange, className }) => {
  return (
    <ReCAPTCHA
      sitekey="6LcCzhMmAAAAAEnfcNBKwDCEgbxofTVeol510R9y"
      onChange={(value) => onChange(value)}
      className={className}
      theme="dark"
      size="normal"
    />
  )
}
